import { localStorage } from '@muse-web/storages'

import { SESSION_DIALOG_IDS } from '../constants/sessionDialogIds'

import { normalizeFlag } from './normalizeFlag'
import { STORAGE_KEYS } from './storageKeys'

export type TSessionDialogState = {
    seenAnniversaryPromo: boolean
    seenOldUsersPromo: boolean
    seenConverterPromo: boolean
    oldUsersPromoShownAtVisit: number | null
}

const EMPTY_STATE: TSessionDialogState = {
    seenAnniversaryPromo: false,
    seenOldUsersPromo: false,
    seenConverterPromo: false,
    oldUsersPromoShownAtVisit: null,
}

const readVisitNumber = (stored: unknown): number | null => {
    if (stored === null || stored === undefined || stored === '') {
        return null
    }

    const parsed = Number(stored)

    return Number.isFinite(parsed) ? parsed : null
}

export const readSessionDialogState = (): TSessionDialogState => {
    if (typeof window === 'undefined') {
        return EMPTY_STATE
    }

    const visited: Record<string, boolean> =
        localStorage.get(STORAGE_KEYS.featurePromosVisited) ?? {}

    return {
        seenAnniversaryPromo: normalizeFlag(localStorage.get(STORAGE_KEYS.anniversaryShown)),
        seenOldUsersPromo: normalizeFlag(localStorage.get(STORAGE_KEYS.oldUsersSeen)),
        seenConverterPromo: visited[SESSION_DIALOG_IDS.converterPromo] === true,
        oldUsersPromoShownAtVisit: readVisitNumber(
            localStorage.get(STORAGE_KEYS.oldUsersPromoShownAtVisit),
        ),
    }
}
